import { useSearch, useSiteContext, useTranslation } from '@eti/providers';
import { useHistory } from 'react-router-dom';
import {
  CAN_NOT_SELECT_TRIP,
  TRAVELER_DETAILS_NO_TRIP_NO_CART,
} from '../../constants/dataLayerEventsConstants';
import { routes as routesConstants } from '../../constants/routesAndApisConstants';
import ErrorDialog from './ErrorDialog';

const NoSelectedTripErrorDialog = () => {
  const { agencyAccount } = useSiteContext();
  const { t } = useTranslation();
  const { currentSearchData } = useSearch();
  const history = useHistory();

  if (currentSearchData?.origin) {
    return (
      <ErrorDialog
        content={t('IbeClient.Error.TripNotAvailable.Content')}
        data-testid="noTrip-error-dialog"
        dataLayerEvent={CAN_NOT_SELECT_TRIP}
        isOpen
        onPrimaryAction={!agencyAccount ? () => history.push(routesConstants.RESULT) : undefined}
        primaryButtonLabel={
          !agencyAccount ? t('IbeClient.Error.TripNotAvailable.Btn.Text') : undefined
        }
        title={t('IbeClient.Error.TripNotAvailable.Header')}
      />
    );
  }

  return (
    <ErrorDialog
      content={t('TravelerDetails.NoTripOrCart.Modal.ContentText')}
      data-testid="noTrip-error-dialog"
      dataLayerEvent={TRAVELER_DETAILS_NO_TRIP_NO_CART}
      isOpen
      onPrimaryAction={!agencyAccount ? () => history.push(routesConstants.START) : undefined}
      primaryButtonLabel={!agencyAccount ? t('TravelerDetails.NoTrip.Modal.ButtonText') : undefined}
      title={t('IbeClient.Error.TripNotAvailable.Header')}
    />
  );
};

export default NoSelectedTripErrorDialog;
